export enum AdvancedWorkflowStatus {
    Unknown = 0,
    InviteFailed = 10,
    AwaitingDonorProfile = 20,
    AwaitingApplicationConfirmation = 30,
    AwaitingNkrReview = 35,
    AwaitingDonorSubmission = 40,
    PendingNkrVerification = 50,
    ReadyToReconcile = 60,
    OnHold = 80,
    Complete = 100,
    Cancelled = 110,
    Declined = 120,
}